import React, { Component } from "react";
import styled from "styled-components";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { CommonStore } from "Store";
import List from "./ListWithQuery";
import InviteModal from "./InviteModalWithMutation";
import Panel from "../common/Panel";
import AddButtonRaw from "../common/AddButton";

export default observer(
  class TeamPanel extends Component {
    states = observable({ showModal: false });

    render() {
      const showModal = this.states.showModal;
      const showAddButton = CommonStore.me.company.theme === null;
      return (
        <Panel title="TEAM MANAGEMENT">
          <AddButton visible={showAddButton} onClick={this.showModal}>
            + Add New Agent
          </AddButton>
          <List />
          {showModal && (
            <InviteModal onCancel={this.hideModal} onConfirm={this.hideModal} />
          )}
        </Panel>
      );
    }

    hideModal = () => {
      this.states.showModal = false;
    };

    showModal = () => {
      this.states.showModal = true;
    };
  }
);

const AddButton = styled(AddButtonRaw)`
  margin-top: 10px;
  margin-bottom: 16px;
  visibility: ${props => (props.visible ? "visible" : "hidden")};
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/team-panel/TeamPanel.js